import { CompareBar } from './compareBar';
import { CompareButton } from './compareButton';
import { CompareIntro } from './compareIntro';
import { CompareMenuItem } from './compareMenuItem';
import { CompareModal } from './compareModal';
import { CompareProvider } from './compareProvider';
import { CompareToggle } from './compareToggle';

export type { CompareProduct } from './compareProvider';

export { MAX_COMPARE, useCompare, useCompareActions } from './compareProvider';
export { compareStorageKey } from './compareStorage';
export { compareProductsTrackingSummary } from './compareTracking';

export const CompareProducts = Object.assign(CompareProvider, {
  Bar: CompareBar,
  Button: CompareButton,
  Intro: CompareIntro,
  MenuItem: CompareMenuItem,
  Modal: CompareModal,
  Toggle: CompareToggle,
});
